import { useNavigate } from 'react-router-dom';

const BlogConvert = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* ── KLANTCASES ────────────────────────────────────────────── */}
      <section className="py-20 bg-[#050010]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Ervaringen ✦</p>
            <h2 className="text-3xl font-bold text-white mb-4">
              Herkenning + actie =<br />
              <span className="text-violet-400">echte resultaten</span>
            </h2>
            <p className="text-white/45 text-sm max-w-xl mx-auto">
              Geen marketingverhalen. Echte situaties van echte mensen die herkenning vonden en handelden.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            {[
              {
                icon: 'ri-moon-line',
                color: 'violet',
                title: 'Baby slaapt eindelijk door',
                situation: 'Mariam\'s baby werd al 6 weken elke nacht meerdere keren wakker, schrikkte hard en was onbedaarlijk. Medisch was er niets gevonden.',
                action: 'Baby Hing Pasta onder het kussen + Destroy Kit voor de kinderkamer',
                result: 'Na 3 dagen rustiger, na een week doorslapen. Moeder huilde van opluchting.',
                name: 'Mariam A.',
                location: 'Rotterdam',
              },
              {
                icon: 'ri-home-heart-line',
                color: 'fuchsia',
                title: 'Rust terug in huis',
                situation: 'Na het betrekken van een nieuw huis constant spanning tussen partner en kinderen. Sfeer nooit prettig ondanks geen echte conflictoorzaken.',
                action: 'Destroy Kit ritueel voor het nieuwe huis + Evil Energy Cologne voor wekelijks dweilen',
                result: 'Sfeer verbeterd binnen één week. Familie zegt het huis nu "warm" en "licht" te voelen.',
                name: 'Hassan & Nadia K.',
                location: 'Amsterdam',
              },
              {
                icon: 'ri-building-2-line',
                color: 'rose',
                title: 'Zaak draait weer',
                situation: 'Nieuwe zaak op locatie waar eerder twee bedrijven failliet gingen. Klanten kwamen nauwelijks ondanks goede service en marketing.',
                action: 'Zakelijk consult + Destroy Kit voor de zaak + Evil Energy Protect Spray dagelijks',
                result: 'Omzetstijging merkbaar na 3 weken. Klanten zeggen de winkel "fijn" te vinden.',
                name: 'Aziz M.',
                location: 'Den Haag',
              },
            ].map(item => {
              const colorMap: Record<string, string> = {
                violet: 'border-violet-500/25 bg-violet-600/8',
                fuchsia: 'border-fuchsia-500/25 bg-fuchsia-600/8',
                rose: 'border-rose-500/25 bg-rose-600/8',
              };
              const iconColor: Record<string, string> = {
                violet: 'text-violet-400 bg-violet-600/20',
                fuchsia: 'text-fuchsia-400 bg-fuchsia-600/20',
                rose: 'text-rose-400 bg-rose-600/20',
              };
              return (
                <div key={item.title} className={`p-6 border rounded-2xl ${colorMap[item.color]}`}>
                  <div className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 ${iconColor[item.color]}`}>
                    <i className={`${item.icon} text-xl`} />
                  </div>
                  <h3 className="text-white font-bold text-base mb-3">{item.title}</h3>
                  <div className="space-y-3 mb-4">
                    <div>
                      <p className="text-white/35 text-xs uppercase tracking-wide font-semibold mb-1">Situatie</p>
                      <p className="text-white/55 text-xs leading-relaxed">{item.situation}</p>
                    </div>
                    <div>
                      <p className="text-white/35 text-xs uppercase tracking-wide font-semibold mb-1">Aanpak</p>
                      <p className="text-white/55 text-xs leading-relaxed">{item.action}</p>
                    </div>
                    <div className="p-3 bg-white/5 rounded-xl">
                      <p className="text-white/35 text-xs uppercase tracking-wide font-semibold mb-1">Resultaat</p>
                      <p className="text-white/75 text-xs leading-relaxed font-medium">{item.result}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 pt-3 border-t border-white/8">
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, s) => <i key={s} className="ri-star-fill text-[#d4a017] text-xs" />)}
                    </div>
                    <span className="text-white/50 text-xs">{item.name}, {item.location}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── WANNEER ACTIE NODIG IS ─────────────────────────────────── */}
      <section className="py-16 bg-gradient-to-b from-[#050010] to-[#0a0018]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="p-8 bg-rose-600/8 border border-rose-500/20 rounded-3xl">
            <div className="text-center mb-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-rose-600/20 mx-auto mb-4">
                <i className="ri-alarm-warning-line text-rose-400 text-3xl" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Wanneer is direct actie nodig?</h2>
              <p className="text-white/50 text-sm">Herken je drie of meer van onderstaande situaties? Wacht dan niet langer.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {[
                'Klachten blijven aanhouden ondanks alle inspanning',
                'Medisch is er niets gevonden maar het gevoel blijft',
                'Baby of kind wordt elke nacht wakker van schrik',
                'Zakelijke stagnatie na 3+ maanden ondanks goede aanpak',
                'Gevoel van aanwezigheid in huis (volwassenen of kinderen)',
                'Structurele onrust in gezin zonder duidelijke oorzaak',
                'Herhaaldelijke conflicten op werk of met familie',
                'Geen verbetering na standaard methoden',
              ].map(item => (
                <div key={item} className="flex items-start gap-3 p-3 bg-rose-500/8 border border-rose-500/15 rounded-xl">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-error-warning-line text-rose-400 text-sm" />
                  </div>
                  <p className="text-white/65 text-sm">{item}</p>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => navigate('/consultations')}
                className="px-8 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold rounded-full whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer flex items-center gap-2"
              >
                <i className="ri-calendar-line" />
                Plan nu een consult
              </button>
              <button
                onClick={() => navigate('/evil-energy-destroy-kit')}
                className="px-8 py-4 border border-rose-500/40 text-rose-300 font-semibold rounded-full whitespace-nowrap hover:bg-rose-500/10 transition-colors cursor-pointer flex items-center gap-2"
              >
                <i className="ri-fire-line" />
                Bekijk de Destroy Kit
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── AANBOD OVERZICHT ──────────────────────────────────────── */}
      <section className="py-20 bg-[#0a0018]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Ons aanbod ✦</p>
            <h2 className="text-3xl font-bold text-white mb-4">Van inzicht naar bescherming —<br />
              <span className="text-violet-400">stap voor stap</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { step: '01', icon: 'ri-search-eye-line', title: 'Intake & inzicht', desc: 'Persoonlijke analyse van jouw situatie via een consult. Inzicht in de oorzaak is de eerste stap naar oplossing.', cta: 'Plan consult', action: '/consultations', color: 'violet' },
              { step: '02', icon: 'ri-shield-star-line', title: 'Beschermingsproducten', desc: 'Dagelijkse bescherming met Blue Protect en Evil Energy Protect serie. Direct toepasbaar, snel resultaat.', cta: 'Bekijk producten', action: '/shop', color: 'fuchsia' },
              { step: '03', icon: 'ri-user-voice-line', title: 'Persoonlijk consult', desc: 'Gerichte spirituele begeleiding voor complexere situaties. Gericht op gezin, huis of werk.', cta: 'Boek nu', action: '/consultations', color: 'rose' },
              { step: '04', icon: 'ri-file-download-line', title: 'Ritueel Blueprint', desc: 'Digitale stap-voor-stap gids voor specifieke reinigingsrituelen. Direct te downloaden na aankoop.', cta: 'Bekijk blueprints', action: '/consultations?tab=blueprints', color: 'amber' },
            ].map(item => {
              const colorMap: Record<string, string> = {
                violet: 'text-violet-400 bg-violet-600/20 border-violet-500/20',
                fuchsia: 'text-fuchsia-400 bg-fuchsia-600/20 border-fuchsia-500/20',
                rose: 'text-rose-400 bg-rose-600/20 border-rose-500/20',
                amber: 'text-amber-400 bg-amber-600/20 border-amber-500/20',
              };
              const [txtColor, bgColor, borderColor] = colorMap[item.color].split(' ');
              return (
                <div key={item.step} className={`p-6 border ${borderColor} bg-white/3 rounded-2xl flex flex-col`}>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl font-black text-white/8">{item.step}</span>
                    <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${bgColor} shrink-0`}>
                      <i className={`${item.icon} text-xl ${txtColor}`} />
                    </div>
                  </div>
                  <h3 className="text-white font-bold text-base mb-2">{item.title}</h3>
                  <p className="text-white/45 text-xs leading-relaxed mb-4 flex-1">{item.desc}</p>
                  <button
                    onClick={() => navigate(item.action)}
                    className={`flex items-center gap-1.5 text-sm font-semibold cursor-pointer ${txtColor} hover:opacity-80 transition-opacity whitespace-nowrap`}
                  >
                    {item.cta} <i className="ri-arrow-right-line" />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── EIND-CTA ─────────────────────────────────────────────── */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/ef96f621776cb5049c051d5a26838c31.jpg"
            alt="Spirituele bescherming gezin"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0018]/85 via-[#0a0018]/75 to-[#0a0018]/90" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto text-center px-6">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-4">✦ Start vandaag ✦</p>
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-6 leading-tight">
            Geef jouw gezin de<br />
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">bescherming die het verdient</span>
          </h2>
          <p className="text-white/60 text-base leading-relaxed mb-10 max-w-xl mx-auto">
            Rust voor je baby. Bescherming voor je huis. Balans voor jou.
            Bewezen sjamaanse kennis — praktisch, direct en zonder angst.
            Zet vandaag de eerste stap.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/consultations')}
              className="px-10 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold rounded-full whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer text-lg flex items-center gap-2"
            >
              <i className="ri-calendar-check-line" />
              Plan een consult
            </button>
            <button
              onClick={() => navigate('/shop')}
              className="px-10 py-4 border-2 border-violet-400/50 text-violet-200 font-bold rounded-full whitespace-nowrap hover:bg-violet-500/15 transition-colors cursor-pointer text-lg flex items-center gap-2"
            >
              <i className="ri-store-2-line" />
              Bescherm jezelf nu
            </button>
          </div>
          <p className="text-white/30 text-sm mt-8">
            <i className="ri-leaf-line mr-1 text-violet-400" />
            Gebaseerd op 40.000 jaar sjamaanse beschermingskennis &middot; 100% natuurlijke producten
          </p>
        </div>
      </section>

      {/* ── GERELATEERDE ARTIKELEN ────────────────────────────────── */}
      <section className="py-16 bg-[#050010]">
        <div className="max-w-[1200px] mx-auto px-6">
          <h3 className="text-xl font-bold text-white mb-6 text-center">Meer lezen?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                id: '1',
                cat: 'Baby & Kind',
                title: "Waarom Baby's 's Nachts Schrikken — En Hoe Je Hen Beschermt",
                time: '6 min',
                img: 'https://readdy.ai/api/search-image?query=sleeping%20peaceful%20baby%20in%20crib%20soft%20warm%20light%20nursery%20room%20gentle%20protection%20spiritual%20energy%20calm%20serene%20nursery%20photography%20dark%20moody%20warm%20tones%20baby%20sleeping%20peacefully%20safe%20protected&width=800&height=500&seq=nb1&orientation=landscape',
              },
              {
                id: '3',
                cat: 'Huisreiniging',
                title: 'Jouw Huis Reinigen na Negatieve Energie — Stap voor Stap',
                time: '7 min',
                img: 'https://readdy.ai/api/search-image?query=incense%20smoke%20sage%20cleansing%20ritual%20dark%20moody%20interior%20home%20spiritual%20purification%20ceremony%20candle%20smoke%20herbal%20mystical%20atmosphere%20home%20protection%20sacred%20ritual%20dark%20background%20warm%20glow&width=800&height=500&seq=nb3&orientation=landscape',
              },
              {
                id: '5',
                cat: 'Sjamanisme',
                title: 'Sjamanisme als Basis voor Dagelijkse Bescherming',
                time: '8 min',
                img: 'https://readdy.ai/api/search-image?query=shamanic%20ritual%20ancient%20wisdom%20dark%20dramatic%20atmosphere%20sacred%20ceremony%20herbs%20smoke%20fire%20mystical%20dark%20background%20ancient%20tradition%20spiritual%20practice%20ceremonial%20powerful&width=800&height=500&seq=nb5&orientation=landscape',
              },
            ].map(art => (
              <div
                key={art.id}
                onClick={() => navigate(`/blog/${art.id}`)}
                className="group bg-white/3 border border-violet-500/10 rounded-2xl overflow-hidden hover:border-violet-500/30 transition-all cursor-pointer"
              >
                <div className="relative h-40 overflow-hidden">
                  <img src={art.img} alt={art.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050010]/70 via-transparent to-transparent" />
                  <span className="absolute top-3 left-3 px-2 py-1 bg-black/50 backdrop-blur-sm text-violet-300 text-xs rounded-full">{art.cat}</span>
                </div>
                <div className="p-4">
                  <h4 className="text-white font-semibold text-sm leading-snug mb-2 group-hover:text-violet-400 transition-colors line-clamp-2">{art.title}</h4>
                  <div className="flex items-center justify-between">
                    <span className="text-white/30 text-xs"><i className="ri-time-line mr-1" />{art.time} leestijd</span>
                    <span className="text-violet-400 text-xs flex items-center gap-1 font-semibold">Meer lezen <i className="ri-arrow-right-line" /></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogConvert;
